import i18next from 'i18next';

i18next.addResources('es', 'search', {
  linkText: 'Limpiar búsqueda',
  itemsFound: 'Hemos encontrado {{count}} resultado',
  withoutResult: 'No hemos encontrado resultados',
  itemsFound_plural: 'Hemos encontrado {{count}} resultados' // eslint-disable-line camelcase
});

i18next.addResources('en', 'search', {
  linkText: 'Clear search',
  itemsFound: 'We found {{count}} result',
  withoutResult: 'We found no results',
  itemsFound_plural: 'We found {{count}} results' // eslint-disable-line camelcase
});

i18next.addResources('pt', 'search', {
  linkText: 'Limpar busca',
  itemsFound: 'Encontramos {{count}} resultado',
  withoutResult: 'Não encontramos resultados',
  itemsFound_plural: 'Encontramos {{count}} resultados' // eslint-disable-line camelcase
});
